// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"styles_iconButton__2p0ft","icon":"styles_icon__1cx_-","small":"styles_small__1DOFp"};